import { Component, computed, effect, inject, input, signal, untracked } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { filter } from "rxjs";

import { Constants } from "../../../../../../constants/constants";
import type { PropTypeModelType, WorkflowDiffVersionType } from "../../../../../../models";
import { PropertiesService } from "../../../../../../services/properties-service";
import {
  AccordionDiffViewComponent,
  AttachmentDiffViewComponent,
  ListDiffViewComponent,
  NormalDiffViewComponent,
} from "../../_lib";
import {
  AccordionSectionConfigType,
  CompositeSectionConfigType,
  ListSectionConfigType,
} from "../../wf-difference.types";
import { govAgentScreenConfig } from "./gov-project-agent-config";
import { govMilestoneScreenConfig } from "./gov-project-milestone-config";
import { govTaskScreenConfig } from "./gov-project-task-config";
import { govTrackScreenConfig } from "./gov-project-track-config";

@Component({
  selector: "adaa-gov-project-screen",
  imports: [
    TranslatePipe,
    NormalDiffViewComponent,
    AttachmentDiffViewComponent,
    AccordionDiffViewComponent,
    ListDiffViewComponent,
  ],
  templateUrl: "./gov-project-screen.html",
})
export class GovProjectScreenComponent {
  private readonly _propertiesService = inject(PropertiesService);

  readonly showOnlyNew = input.required<boolean>();
  readonly itemType = input.required<number>();
  readonly isNew = input<boolean>(false);
  readonly newObject = input<WorkflowDiffVersionType>();
  readonly oldObject = input<WorkflowDiffVersionType>();
  readonly viewOnlyDifferences = input<boolean>(false);

  private readonly _newObject = computed<WorkflowDiffVersionType>(() => this.newObject() ?? {});
  private readonly _oldObject = computed<WorkflowDiffVersionType>(() => this.oldObject() ?? {});

  config = computed(() => this._getConfig(this.itemType()));
  props = signal<PropTypeModelType[]>([]);

  newData = computed(() => {
    const object = this._newObject();

    return object;
  });

  oldData = computed(() => {
    const object = this._oldObject();

    return object;
  });

  readonly $asAccordionConfig = ($s: CompositeSectionConfigType) => $s as AccordionSectionConfigType;
  readonly $asListConfig = ($s: CompositeSectionConfigType) => $s as ListSectionConfigType;

  constructor() {
    effect(() => {
      if (this.itemType() !== Constants.GOV_MILESTONES.AI) return;

      untracked(() => this._loadTaskTypes());
    });
  }

  private _loadTaskTypes() {
    this._propertiesService
      .getPropById(Constants.CONSTANT_GOV_TASK_TYPES)
      .pipe(filter((res) => !res.inError))
      .subscribe({
        next: (res) => this.props.set(res.responseData ?? []),
      });
  }

  private _getConfig(itemType: number) {
    switch (itemType) {
      case Constants.GOV_TRACKS.AI:
        return govTrackScreenConfig;
      case Constants.GOV_MILESTONES.AI:
        return govMilestoneScreenConfig;
      case Constants.GOV_TASKS.AI:
      case Constants.CONSTANT_WORKFLOW.AITASK:
        return govTaskScreenConfig;
      case Constants.AI_AGENTS:
        return govAgentScreenConfig;
      default:
        return undefined;
    }
  }
}
